import React from 'react';
import { ArrowUpRight, Mail } from 'lucide-react';
import Header from '../../components/landing/Header';
import Footer from '../../components/landing/Footer';
import { pressCoverage } from '../../data/pressCoverage';

const [featured, ...rest] = pressCoverage;

const News = () => (
  <div className="min-h-screen bg-white overflow-x-hidden">
    <Header />

    <section className="border-b border-neutral-200 bg-white pt-36 pb-8 sm:pt-40 sm:pb-10">
      <div className="mx-auto max-w-6xl px-6 sm:px-10 lg:px-16">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">
          Press & Coverage
        </p>
        <h1 className="mt-2 text-3xl font-semibold leading-tight tracking-tight text-neutral-900 sm:text-4xl">
          What's been written about us.
        </h1>
        <p className="mt-3 max-w-2xl text-sm text-neutral-600 sm:text-base">
          A selection of features from the outlets that have covered PetCart, PetCart Nest and Wag
          &amp; Wine since 2018.
        </p>
      </div>
    </section>

    <section className="bg-white pt-8 pb-4 sm:pt-10 sm:pb-6">
      <div className="mx-auto max-w-6xl px-6 sm:px-10 lg:px-16">
        <a
          href={featured.href}
          target="_blank"
          rel="noopener noreferrer"
          className="group relative block overflow-hidden rounded-2xl border border-primary/30 bg-primary/[0.04] transition-colors hover:border-primary"
        >
          <span aria-hidden className="absolute inset-y-0 left-0 w-1 bg-primary" />
          <div className="grid gap-6 px-6 py-7 sm:grid-cols-[1fr_auto] sm:items-end sm:gap-10 sm:px-10 sm:py-9 lg:px-12">
            <div>
              <div className="flex items-center gap-3">
                <span className="inline-flex items-center rounded-full bg-primary px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-white">
                  Featured
                </span>
                <span className="text-[11px] font-semibold uppercase tracking-wider text-neutral-500">
                  {featured.outlet} · {featured.year}
                </span>
              </div>
              <h2 className="mt-4 max-w-2xl text-xl font-semibold leading-snug text-neutral-900 sm:text-2xl lg:text-[28px]">
                {featured.title}
              </h2>
              <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-neutral-900 group-hover:text-primary">
                Read on {featured.outlet}
                <ArrowUpRight size={15} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </span>
            </div>
            <div className="flex items-center justify-start sm:justify-end">
              <div className="rounded-lg border border-neutral-200 bg-white px-5 py-3">
                <img
                  src={featured.logo}
                  alt={featured.outlet}
                  className="h-7 w-auto object-contain sm:h-9"
                />
              </div>
            </div>
          </div>
        </a>
      </div>
    </section>

    <section className="bg-neutral-50 py-10 sm:py-14">
      <div className="mx-auto max-w-6xl px-6 sm:px-10 lg:px-16">
        <h3 className="text-lg font-semibold text-neutral-900 sm:text-xl">
          More coverage
        </h3>
        <ul className="mt-5 divide-y divide-neutral-200 border-y border-neutral-200 sm:mt-6">
          {rest.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="group grid grid-cols-[120px_1fr_auto] items-center gap-6 py-5 sm:grid-cols-[180px_1fr_auto] sm:gap-10 sm:py-7"
              >
                <div className="flex h-12 items-center sm:h-14">
                  <img
                    src={item.logo}
                    alt={item.outlet}
                    className="max-h-full w-auto object-contain"
                  />
                </div>
                <div className="min-w-0">
                  <p className="text-[11px] font-semibold uppercase tracking-wider text-neutral-500">
                    {item.outlet} · {item.year}
                  </p>
                  <p className="mt-1 text-base font-medium leading-snug text-neutral-900 group-hover:text-primary sm:text-lg">
                    {item.title}
                  </p>
                </div>
                <ArrowUpRight
                  size={18}
                  className="text-neutral-400 transition-colors group-hover:text-primary"
                />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>

    <section className="bg-neutral-900 py-16 text-white sm:py-20">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 px-4 sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">
            For journalists
          </p>
          <h2 className="mt-2 text-2xl font-semibold sm:text-3xl">
            Writing about PetCart? We're happy to help.
          </h2>
          <p className="mt-3 max-w-xl text-sm text-white/70">
            Interviews, on-site visits, brand assets, or a quote from our founder — drop us a line
            and we'll get back the same day.
          </p>
        </div>
        <a
          href="mailto:shekhar@petcart.com"
          className="inline-flex items-center gap-2 self-start rounded-md bg-white px-5 py-2.5 text-sm font-semibold text-neutral-900 hover:bg-white/90 sm:self-auto"
        >
          <Mail size={15} /> shekhar@petcart.com
        </a>
      </div>
    </section>

    <Footer />
  </div>
);

export default News;
